import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AgencyStateService } from '../../services/agency-state.service';

export const agencyReportsGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router);
  const agencyState = inject(AgencyStateService);

  // Wait for /users/me to populate userRole + agencyReportsAccess; cold-loads
  // (e.g. bookmark to /agency/reports) would otherwise see null and bounce
  // a valid user away.
  await agencyState.ensureInitialized();

  const access = agencyState.agencyReportsAccess$.value ?? 'NONE';
  const userRole = agencyState.userRole$.value;

  if (
    userRole === 'SHOP_OWNER' ||
    userRole === 'SHOP_SPY' ||
    userRole === 'ADMIN' ||
    access !== 'NONE'
  ) {
    return true;
  }
  // Preserve the /demo prefix so a demo session denied access doesn't get
  // bounced out of the demo subtree (and through DemoGuard → authGuard).
  // (bd-1utn)
  return router.createUrlTree([AgencyStateService.demoAwareUrl(state.url, '/agency/dashboard')]);
};
